import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const getDateFilter = (data, callback) => {
    return fetchDataAndProceed('admin/v1/nlp/cluster/keydate', METHOD_TYPES.GET, data, callback)
};

export const getClusterData = (data, callback) => {
    return fetchDataAndProceed('admin/v1/nlp/cluster/clusterdiagram', METHOD_TYPES.POST, data, callback)
};

export const fetchTableData = (data, callback) => {
    return fetchDataAndProceed('admin/v1/nlp/cluster/clusterdata', METHOD_TYPES.POST, data, callback)
};

export const getUtterances = (data, callback) => {
    return fetchDataAndProceed('admin/v1/nlp/cluster/clusterdatautter', METHOD_TYPES.POST, data, callback)
};

export const getWordCloudData = (data, callback) => {
    return fetchDataAndProceed('admin/v1/analytics/worldCloud', METHOD_TYPES.POST, data, callback)
};


// WEBPACK FOOTER //
// ./src/data/redux/query_details/api.js